export default __webpack_public_path__ + "static/Snow Peak Logo-cd11d635556c014eeac8d010e4fa62dd.png";